// Widget Studio — instance detail page (CHG-2460 / ITER-905202, Widget Studio S3).
//
// Thin wrapper: all configuration in @generated/screens/widget-instance-detail,
// regenerated from specs/tier-05-experience/widget-instance.entity-hint.yaml.
// Lifecycle actions + the presentation Edit dialog are driven by the imperative
// host (lib/widget-instance-actions, mounted once in App.tsx). Route
// /channels/widgets/:widgetInstanceId.

import { DetailPage } from "../components/composition";
import { widgetInstanceDetailConfig } from "../generated/screens/widget-instance-detail";

export function WidgetDetail() {
  return <DetailPage config={widgetInstanceDetailConfig} />;
}
